export default __webpack_public_path__ + "static/media/news.88cec393.webp";